import Config from '../config'
import fetcher from '../lib/fetcher'

export const getApplication = () => {
  return fetcher(`directory/api/application/0/`)
    .setConfig(Config)
    .get()
}